













import { defineComponent, computed, ref, Ref } from '@vue/composition-api'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheck,
  faSyncAlt,
  faExclamationCircle,
  faFileUpload,
  faQuestion
} from '@fortawesome/free-solid-svg-icons'
library.add(faCheck, faSyncAlt, faExclamationCircle, faFileUpload, faQuestion)

const promiseStatuses = ['pending', 'resolved', 'rejected', 'unknown'] as const
type PromiseStatus = typeof promiseStatuses[number]

function promiseStatus(promise): Ref<PromiseStatus> {
  const status = ref<PromiseStatus>('unknown')

  if (!promise) return status

  if (promise.isResolved) {
    status.value = 'resolved'
    return status
  }

  promise.then(
    function(v) {
      status.value = 'resolved'
      return v
    },
    function(e) {
      status.value = 'rejected'
      throw e
    }
  )

  return status
}

const statusIcons: Record<PromiseStatus, string> = {
  unknown: 'file-upload',
  pending: 'sync-alt',
  rejected: 'exclamation-circle',
  resolved: 'check'
}

const toStatusIcon = (status: PromiseStatus): string => statusIcons?.[status]

const shouldSpin = (status: PromiseStatus): boolean => status == 'pending'

const statusColors: Record<PromiseStatus, string> = {
  unknown: 'gray',
  pending: 'blue',
  rejected: 'red',
  resolved: 'green'
}

const toStatusColor = (status: PromiseStatus): string => statusColors?.[status]

export default defineComponent({
  props: {
    upload: Promise
  },

  setup(props) {
    const statusIcon = computed(() => {
      const status = promiseStatus(props.upload)
      toStatusIcon(status.value)
    })
    const statusColor = computed(() => {
      const status = promiseStatus(props.upload)
      toStatusColor(status.value)
    })
    const spins = computed(() => {
      const status = promiseStatus(props.upload)
      shouldSpin(status.value)
    })

    return {
      status,
      statusIcon,
      spins,
      statusColor
    }
  }
})
